import React, { useState } from "react";
import classes from "./bookingCard.module.css";
import moment from "moment";
import momentTimezone from "moment-timezone";
import { Cancel, EventRepeat, Info, Close } from "@mui/icons-material"; // Importing MUI icons
import { CheckCircle, ThumbsDown, ThumbsUp, XCircle } from "lucide-react";
import ConfirmationModal from "./confirmationModal";
import { useDispatch } from "react-redux";
import {
  bookingAction,
  cancelBooking,
  fetchBookingsByFilter,
} from "../../../../../redux/slices/bookingSlice";
import RejectionModal from "./rejectionModal";
import CancelModal from "./CancelModal";

const BookingCard = ({
  appointment,
  index,
  onRescheduleClick,
  sessionDetails,
  appointmentTime,
  highlightedIndex,
  setHighlightedIndex,
  meetingLink,
  therapist,
  setDisplayContainerIndex,
  displayContainerIndex,
  userDetails,
  status,
}) => {
  const [displayDetailsContainer, setDisplayDetailsContainer] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const userTimeZone = momentTimezone.tz.guess();

  // Use the appointment data if available, otherwise fall back to props
  const actualAppointment = appointment || {
    _id: "67df1657957ee6b4b8d2bde0",
    date: appointmentTime || "2025-03-30T00:00:00.000Z",
    duration: 3,
    details: "let's go",
    status: status || "pending_approval",
    amount: 3000,
  };

  const actualDate = actualAppointment.date || appointmentTime;
  const localAppointmentTime = moment(actualDate).tz(userTimeZone);
  const formattedDate = localAppointmentTime.format("D MMMM"); // Example: "30 March"
  const formattedTime = localAppointmentTime.format("h:mm A"); // Example: "12:00 AM"

  const dispatch = useDispatch();

  // Calculate time difference in hours between now and the appointment time
  const hoursUntilAppointment = localAppointmentTime.diff(moment(), "hours");
  const canModifyAppointment = true;

  const handleDisplayDetails = () => {
    setDisplayDetailsContainer(!displayDetailsContainer);
  };

  const handleCloseDisplayDetailsContainer = () => {
    setDisplayDetailsContainer(false);
  };
  const handleCloseRejectModal = () => {
    setIsRejectModalOpen(false);
  };

  const onApprove = () => {
    setIsConfirmModalOpen(true);
  };

  const onConfirmApproval = async () => {
    try {
      dispatch(
        bookingAction({
          bookingId: appointment._id,
          action: "accept",
          status: "accepted",
        })
      );
      dispatch(
        fetchBookingsByFilter({
          type: "artist",
          status: "pending_approval",
        })
      );
      // Close the modal
      setIsConfirmModalOpen(false);
    } catch (error) {
      console.error("Approval failed:", error);
    }
  };

  const onConfirmRejection = async () => {
    try {
      dispatch(
        bookingAction({
          bookingId: appointment._id,
          action: "reject",
          status: "rejected",
        })
      );
      // Close the modal
      setIsRejectModalOpen(false);
    } catch (error) {
      console.error("Rejection failed:", error);
    }
  };

  const onDisapprove = () => {
    // Open rejection modal instead of immediate action
    setIsRejectModalOpen(true);
  };

  const handleContainerClick = () => {
    // setHighlightedIndex(null);
  };

  const handleCancelClick = () => {
    setIsCancelModalOpen(true);
  };

  const handleCancelBooking = () => {
    dispatch(
      cancelBooking({
        bookingId: appointment._id,
      })
    );
    // Close the modal
    setIsCancelModalOpen(false);
  };

  const handleCloseCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  return (
    <>
      <div
        className={classes.outerMostContainer}
        style={{
          border: `${
            highlightedIndex === index ? "1px solid white" : "1px solid white"
          }`,
        }}
        onClick={() => {
          if (highlightedIndex === index) {
            handleContainerClick();
          }
        }}
      >
        <div className={classes.therapyDetailsContainer}>
          <Info fontSize="large" /> {/* Therapy icon */}
          <div className={classes.therapyDetailsSubContainer}>
            <p className={classes.appointmentNameTxt}>{`Singing Event`}</p>

            <p
              className={classes.appointmentTimeTxt}
            >{`${formattedDate} | ${formattedTime} `}</p>
          </div>
        </div>
        {actualAppointment.status !== "pending_approval" && (
          <div className={classes.appointmentControlsContainer}>
            {canModifyAppointment && (
              <div
                className={classes.appointmentItemContainer}
                onClick={handleCancelClick}
              >
                <Cancel fontSize="medium" /> {/* Cancel icon */}
                <p className={classes.btnLabel}>{"Cancel"}</p>
              </div>
            )}

            <div className={classes.verticalLineAfterReschedule}></div>

            <div
              className={classes.appointmentItemContainer}
              onClick={handleDisplayDetails}
            >
              <Info fontSize="medium" /> {/* Details icon */}
              <p className={classes.btnLabel}>{"Details"}</p>
            </div>
          </div>
        )}
        {actualAppointment.status === "pending_approval" && (
          <div className={classes.pendingApprovalContainer}>
            <button
              className={`${classes.button} ${classes.approve}`}
              onClick={onApprove}
            >
              <CheckCircle />
            </button>
            <button
              className={`${classes.button} ${classes.disapprove}`}
              onClick={onDisapprove}
            >
              <XCircle />
            </button>
            <div
              className={classes.appointmentItemContainer}
              onClick={handleDisplayDetails}
            >
              <Info fontSize="medium" /> {/* Details icon */}
              <p className={classes.btnLabel}>{"Details"}</p>
            </div>
          </div>
        )}
        <div
          className={classes.appointmentItemContainerMobile}
          onClick={handleDisplayDetails}
        >
          <Info fontSize="medium" /> {/* Details icon */}
        </div>
        {displayDetailsContainer && displayContainerIndex === index && (
          <div className={classes.openDetailsContainer}>
            <div className={classes.therapyDetailsContainer}>
              <div className={classes.closeBtnMobile}>
                <Close
                  fontSize="small"
                  className={classes.closeBtnMobile}
                  onClick={handleCloseDisplayDetailsContainer}
                />
              </div>
              {/* Close button */}
              <Info fontSize="large" /> {/* Therapy icon */}
              <div className={classes.therapyDetailsSubContainer}>
                <p className={classes.appointmentNameTxt}>{`Singing Event`}</p>

                <p
                  className={classes.appointmentTimeTxt}
                >{`${formattedDate} | ${formattedTime} `}</p>

                <p className={classes.appointmentTimeTxt}>
                  {`Client Name: ${
                    appointment?.customerFullName?.charAt(0)?.toUpperCase() +
                      appointment?.customerFullName?.slice(1) || "N/A"
                  } , Phone Number: ${appointment?.customerPhoneNumber}`}
                </p>

                <p className={classes.appointmentTimeTxt}>
                  {`Duration: ${actualAppointment?.duration} hours`}
                </p>

                <p className={classes.appointmentTimeTxt}>
                  {`Amount: ₹${actualAppointment?.amount}`}
                </p>

                <p className={classes.appointmentTimeTxt}>
                  {`Details: ${actualAppointment?.details}`}
                </p>

                <p className={classes.appointmentTimeTxt}>
                  {`Address: ${actualAppointment?.address}, PinCode: ${actualAppointment?.pincode}, State: ${actualAppointment?.state}`}
                </p>
              </div>
            </div>
            {actualAppointment.status !== "pending_approval" && (
              <div
                className={classes.appointmentControlsContainerRescheduleBox}
              >
                <div
                  className={classes.appointmentItemContainerRescheduleBox}
                  onClick={handleCancelClick}
                >
                  <Cancel fontSize="medium" /> {/* Cancel icon */}
                  <p className={classes.btnLabel}>{"Cancel"}</p>
                </div>
                <div className={classes.verticalLineAfterReschedule}></div>

                <div
                  className={
                    classes.appointmentItemContainerDetailsRescheduleBox
                  }
                  onClick={handleDisplayDetails}
                >
                  <Info fontSize="medium" className={classes.detailsIcon} />{" "}
                  {/* Details icon */}
                  <p className={classes.detailsBtnLabel}>{"Details"}</p>
                  <p
                    className={classes.closeBtn}
                    onClick={handleCloseDisplayDetailsContainer}
                  >
                    {"Close"}
                  </p>
                </div>
              </div>
            )}
            {actualAppointment.status == "pending_approval" && (
              <div>
                <p
                  className={classes.closeBtn}
                  onClick={handleCloseDisplayDetailsContainer}
                >
                  {"Close"}
                </p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Confirmation Modal for Approval */}
      <ConfirmationModal
        isOpen={isConfirmModalOpen}
        onClose={handleCloseConfirmModal}
        onConfirm={onConfirmApproval}
        appointmentDate={formattedDate}
        appointmentTime={formattedTime}
        appointmentDetails={actualAppointment}
      />

      <RejectionModal
        isOpen={isRejectModalOpen}
        onClose={handleCloseRejectModal}
        onConfirm={onConfirmRejection}
        appointmentDate={formattedDate}
        appointmentTime={formattedTime}
        appointmentDetails={actualAppointment}
      />

      {/* Cancel Modal would go here */}
      <CancelModal
        closeModal={handleCloseCancelModal}
        isModalOpen={isCancelModalOpen}
        handleOnCancelClick={handleCancelBooking}
        date={formattedDate}
        time={formattedTime}
      />
    </>
  );
};

export default BookingCard;
